<template>
  <div class="row">
     <div class=" col-md-12 modal-body-expense">
      <div class="row" style="padding: 5px;">
          <div class="col-md-12">
              <!-- <div class="alert alert-danger" v-if="errors.length">
        <strong>Whoops!</strong> There were some problems with your input.<br><br>
        <ul>
                <li v-for="error in errors">{{ error }}</li>
        </ul>
    </div> -->
              <div class="row">
                  <div class="col-8">
                      <div class="text-left section-title" style="padding: 5px;">
                          <span class="row-table-font-margins" style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center'>
                              Additional Expenses
                          </span>
                      </div>
                  </div>

              </div>
              <div class="row">
                  <div class="col-xs-6 col-sm-6 col-md-6">
                      <div class="form-group">
                          <label>ExpenseTypes:</label>

                          <select class="form-control" v-model="expense.expenseTypeId">
                              <option v-for="expenseType in expenseTypes"
                                      v-bind:key="expenseType.id"
                                      :value="expenseType.id">
                                  {{ expenseType.name }}
                              </option>
                          </select>
                          <div v-show="!expense.expenseTypeId & submitted"
                               class="invalid-feedback"
                               style>
                              Expense type is required
                          </div>
                      </div>
                  </div>

                  <div class="col-xs-6 col-sm-6 col-md-6">
                      <div class="form-group">
                          <label>Principal:</label>
                          <select id="registered-owner"
                                  :disabled="expense.expenseTypeId == null"
                                  class="form-control"
                                  v-model="expense.supplierId">
                              <option v-for="supplier in serviceProviderFilter(
                        expense.expenseTypeId
                      )"
                                      :key="supplier.id"
                                      :value="supplier.id">
                                  {{ supplier.name }}
                              </option>
                          </select>
                          <div v-show="!expense.supplierId & submitted"
                               class="invalid-feedback"
                               style>
                              Creditor is required
                          </div>
                      </div>
                  </div>
              </div>
              <div class="row">
                  <div class="col-xs-6 col-sm-6 col-md-6">
                      <div class="form-group">
                          <label>Amount :</label>
                          <input class="form-control"
                                 type="text"
                                 number
                                 v-model="expense.amount" />
                          <div v-show="!expense.amount & submitted"
                               class="invalid-feedback"
                               style="margin-left: 67px;">
                              Amount is required
                          </div>
                      </div>
                  </div>
                  <div class="col-xs-6 col-sm-6 col-md-6">
                      <div class="form-group">
                          <label>VAT% :</label>
                          {{ getVATPercentage(expense.expenseTypeId) }}
                      </div>
                      <div class="form-group">
                          <label>Net Amount :</label>
                          {{ $filters.toCurrency(getNetAmount) }}
                      </div>
                      <div class="form-group">
                          <label>VAT Amount :</label>
                          {{ $filters.toCurrency(expense.vatAmount) }}
                      </div>
                  </div>






              </div>
              <div class="row">
                  <div class="col-xs-6 col-sm-6 col-md-6">
                      <div class="form-group">
                          <label>Invoice No:</label>
                          <input type="text"
                                 class="form-control"
                                 v-model="expense.invoiceNo" />
                      </div>
                  </div>
                  <div class="col-xs-6 col-sm-6 col-md-6">
                      <div class="form-group">
                          <label> Due date :</label>
                          <date-picker class="form-control"
                                       :format="customFormatter"
                                       v-model="expense.dueDate" />
                          <div v-show="!expense.dueDate & submitted"
                               class="invalid-feedback"
                               style="margin-left: 71px;">
                              Date is required
                          </div>
                      </div>
                  </div>
              </div>
                 
                  <div class="row">
                      <div class="table-responsive col-md-12" style="box-shadow:none;border:0">
                          <div v-if="building.isComplex">
                              <table class="table table-condensed" style="width: 100%;">
                                  <thead class="">
                                      <tr>
                                          <th style="

                        width: 20%;
                      "
                                              class="no-border text-center">
                                              No
                                          </th>
                                          <th style="

                        width: 20%;
                      "
                                              class="no-border text-center">
                                              Building
                                          </th>
                                          <th style="

                        width: 20%;
                      "
                                              class="no-border text-center">
                                              Property
                                          </th>
                                          <th style="

                        width: 20%;
                      "
                                              class="no-border text-center">
                                              Square Meters
                                          </th>
                                          <th style="

                        width: 20%;
                      "
                                              class="no-border text-center">
                                              Sq. Meters %
                                          </th>
                                          <th style="

                        width: 20%;
                      "
                                              class="no-border text-center col-md-3">
                                              Amount
                                          </th>
                                          <th class="no-border col-md-2">
                                              <button :disabled="expense.amount <= 0"
                                                      class="btn btn-primary"
                                                      @click="distribute()"
                                                      onclick="return false;">
                                                  Distribute Amount
                                              </button>
                                          </th>
                                      </tr>
                                  </thead>
                                  <tbody style="border: 1px solid rgba(221, 221, 221, 1);">
                                      <tr v-for="(property, key) in properties"
                                          :key="property.property.id">
                                          <td class="text-center">
                                              {{ ++key }}
                                          </td>
                                          <td class="text-center">
                                              {{ property.building.name }}
                                          </td>
                                          <td class="text-center">
                                              {{ property.property.floor }} -
                                              {{ property.property.number }}
                                          </td>
                                          <td class="text-center">
                                              {{ property.property.square_meters }}
                                          </td>
                                          <td class="text-center">
                                              {{
                        (
                          (property.property.square_meters * 100) /
                          totalSquareMeters
                        ).toFixed(2)
                                              }}%
                                          </td>
                                          <td>
                                              <input type="text"
                                                     number
                                                     class="form-control text-right"
                                                     v-model="property.amount"
                                                     data-type="currency" />
                                          </td>
                                          <td></td>
                                      </tr>
                                  </tbody>
                              </table>
                          </div>
                          <div v-else>
                              <table class="table table-condensed" style="100%">
                                  <thead class="">
                                      <tr>
                                          <th style="

                        width: 10.5%;
                      "
                                              class="no-border text-center">
                                              No
                                          </th>
                                          <th style="

                        width: 15.5%;
                      "
                                              class="no-border text-center">
                                              Property
                                          </th>
                                          <th style="

                        width: 15.5%;
                      "
                                              class="no-border text-center">
                                              Square Meters
                                          </th>
                                          <th style="

                        width: 15.5%;
                      "
                                              class="no-border text-center">
                                              Sq. Meters %
                                          </th>
                                          <th style="

                        width: 15.5%;
                      "
                                              class="no-border text-center">
                                              Amount
                                          </th>
                                          <th class="no-border" style="width: 15%;">
                                              <button style="width: 100%;"
                                                      :disabled="expense.amount <= 0"
                                                      class="btn btn-primary"
                                                      @click="distributeToSelected()"
                                                      onclick="return false;">
                                                  Distribute To Selected
                                              </button>
                                          </th>
                                          <th class="no-border" style="width: 15%;">
                                              <button style="width: 100%;"
                                                      :disabled="expense.amount <= 0"
                                                      class="btn btn-primary"
                                                      @click="distribute()"
                                                      onclick="return false;">
                                                  Distribute Amount
                                              </button>
                                          </th>
                                      </tr>
                                  </thead>
                                  <tbody style="border: 1px solid rgba(221, 221, 221, 1);">
                                      <tr v-for="(property, key) in properties" :key="property.id">
                                          <td class="text-center">
                                              {{ ++key }}
                                          </td>

                                          <td class="text-center">
                                              {{ property.propertyName }}
                                          </td>
                                          <td class="text-center">
                                              {{ property.squareMeters }}
                                          </td>
                                          <td class="text-center">
                                              {{
                        (
                          (property.squareMeters * 100) /
                          totalSquareMeters
                        ).toFixed(2)
                                              }}%
                                          </td>
                                          <td>
                                              <input type="text"
                                                     number
                                                     class="form-control text-right"
                                                     v-model="property.amount"
                                                     data-type="currency" />
                                          </td>
                                          <td class="text-center">
                                              <input type="checkbox" v-model="property.isSelected" />
                                          </td>
                                          <td></td>
                                      </tr>
                                      <tr>
                                          <td class="text-center"></td>

                                          <td class="text-center"></td>
                                          <td class="text-center"></td>
                                          <td class="text-center">
                                              <strong>Total</strong>
                                          </td>
                                          <td class="text-right">
                                              <strong>{{ TotalAmount }} </strong>
                                          </td>
                                          <td class="text-center"></td>
                                          <td></td>
                                      </tr>
                                  </tbody>
                              </table>
                              <div v-show="formIsNotValid & submitted"
                                   class="invalid-feedback"
                                   style="font-width: bold; font-size: 16px; text-align: center;">
                                  Form invalid, recheck the input
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="col-xs-12 col-sm-12 col-md-12 text-center">
                      <div class="text-center">
                          <button type="submit" @click="save()" class="btn btn-submit" style="margin: 15px;">
                              Submit
                          </button>
                          <button @click="closeModal()" class="btn btn-cancel">Cancel</button>
                      </div>

                  </div>
              </div>
          </div>
    </div>
    <div
      id="dialog-confirm"
      title="Empty the recycle bin?"
      style="display: none;"
    >
      <p>
        <span
          class="ui-icon ui-icon-alert"
          style="float: left; margin: 12px 12px 20px 0;"
        ></span
        >These items will be permanently deleted and cannot be recovered. Are
        you sure?
      </p>
    </div>
  </div>
</template>
<style scoped>
.invalid-feedback {
  font-size: 14px;
  /* margin-top:-1px; */
  /* color:rgb(56, 56, 56); */
  color: #c7254e;
}
</style>
<script>
import { format } from "date-fns";
export default {
  props: ["buildingId"],
  data: function () {
    return {
      expenseTypes: {},
        expense: [],
      vatPercentage: 0,
      properties: [],
      suppliers: [],
      building: {},
      building_id: 0,
      totalSquareMeters: 0,
      errors: [],
      buildingName: "",
      submitted: false,
    };
  },
  watch: {
    value(val) {
      this.$emit("update:buildingId", val);
    },
    buildingId(val) {
      this.value = val;
      this.fetchProperty();
    },
  },

  mounted() {
    this.buildingName = this.$route.params.buildingName;
    this.building_id = this.buildingId;

    if (this.buildingId) this.fetchProperty();
  },

  methods: {
    fetchProperty: async function () {
      var request = "/additionalexpenses/providers";
      // if(this.route=="home")
      //   request = '/home/statment/get/';
      request = request + "?id=" + this.buildingId;
      this.$http
        .get(request, {
          id: this.buildingId,
        })
        .then(({ data }) => {
          this.mute = false;
          //this.contacts = data.contacts;
          this.mute = false;
          // let myObjStr = JSON.stringify(data.expenseFees);
          this.expense = data.expense;
          this.suppliers = data.suppliers;
          this.expenseTypes = data.expenseTypes;
            this.properties = data.properties;
            for (var i = 0; i < this.properties.length; i++)
                this.properties[i].amount = undefined;
            this.totalSquareMeters = data.totalSquareMeters;
            if (this.expense.amount == 0)
                this.expense.amount = undefined
        });
    },
    /*fetchProperty: async function() {
								try {
									this.mute = true;
									const response = await axios.get('/admin/additionalexpense/get/'+ this.building_id);
									this.mute = false;
									this.expense = response.data.expense;
									this.properties = response.data.properties;
									this.expense_types = response.data.expense_types;
									this.building = response.data.building;
									this.serviceProviders = response.data.serviceProviders;
									this.totalSquareMeters = response.data.totalSquareMeters;
                                    } catch (error) {
                                        alert(error);
                                    }
                            },*/
    serviceProviderFilter: function (expenseType_id) {
      var items = this.suppliers;

      var result = items.filter(function (item) {
        return item.serviceTypes.some(
          (x) => x.expenseTypeId && x.expenseTypeId === expenseType_id
        );
      });

      return result;
    },
    customFormatter(date) {
      //alert(moment(date).format('dd/MM/YYYY'));
      //return date | moment("dddd, MMMM Do YYYY")
      return format(date, "dd/MM/yyyy");
    },
    showDialog: function () {
      $("#dialog-confirm").dialog({
        resizable: false,
        height: "auto",
        width: 400,
        modal: true,
        buttons: {
          "Delete all items": function () {
            $(this).dialog("close");
            return true;
          },
          Cancel: function () {
            $(this).dialog("close");
            return false;
          },
        },
      });
    },

    distributeToSelected: function () {
      try {
        var amount = this.expense.amount;
        var square_meter_percent = 0;
        var totalSqm = 0;
        for (var i = 0; i < this.properties.length; i++) {
          if (this.properties[i].isSelected)
            totalSqm += this.properties[i].squareMeters;
        }

        for (i = 0; i < this.properties.length; i++) {
          if (this.properties[i].isSelected) {
            square_meter_percent = 0;
            square_meter_percent =
              (this.properties[i].squareMeters * 100) / totalSqm;
            this.properties[i].amount = parseFloat(
              (amount * square_meter_percent) / 100
            ).toFixed(2);
          } else this.properties[i].amount = 0;
        }
      } catch (e) {
        alert(e);
      }
    },

    distribute: function () {
      try {
        var amount = this.expense.amount;
        for (var i = 0; i < this.properties.length; i++) {
          var square_meter_percent = 0;
          square_meter_percent =
            (this.properties[i].squareMeters * 100) / this.totalSquareMeters;
          this.properties[i].amount = parseFloat(
            (amount * square_meter_percent) / 100
          ).toFixed(2);
        }
      } catch (e) {
        alert(e);
      }
      },
      getVATPercentage(expenseId) {
          if (expenseId == undefined) {
              this.vatPercentage = 0
              return 0;
          }
          var expenseTemp = this.expenseTypes.find(expenseType => {
              return expenseType.id == expenseId
          })

          if (expenseTemp == undefined) {
              this.vatPercentage = 0
              return 0;
          }
              
          this.vatPercentage = expenseTemp.vatPercentage
          return expenseTemp.vatPercentage
      },
      

    closeModal: function () {
        this.$modal.hide("control-panel-add-form");
    },

    checkForm: function () {
      var canSubmit =
        this.expense.expenseTypeId &&
        this.expense.expenseTypeId &&
        this.expense.supplierId &&
        this.expense.amount &&
        this.expense.dueDate;
      this.errors = [];

      // if (!this.expense.expenseTypeId) {
      // 		this.errors.push('Please select expense type.');
      // 	}

      // if (!this.expense.supplierId) {
      // 		this.errors.push('Please select creditor.');
      // 	}

      // 	if (this.expense.amount <= 0) {
      // 		this.errors.push('Please enter expense amount.');
      // 	}

      // 	if (!this.expense.dueDate) {
      // 		this.errors.push('Please enter expense date.');
      // 	}

      var paymentAmount = parseFloat(this.expense.amount).toFixed(2);

      var allocatedAmount = 0;
      for (var i = 0; i < this.properties.length; i++) {
        allocatedAmount += parseFloat(this.properties[i].amount == undefined ? 0 : this.properties[i].amount);
      }

      if (paymentAmount != allocatedAmount.toFixed(2)) {
        if (canSubmit) {
          var sum = 0;
          for (var j = 0; j < this.properties.length; j++) {
              sum += parseFloat(this.properties[j].amount == undefined ? 0 : this.properties[j].amount);
          }

          /*	var options = {
											loader: true,
											type: 'hard'
										};*/
          //var answer =this.showDialog();
          /*var answer = this.$dialog.confirm("Expense amount is €" + this.expense.amount + " but \n you have distributed €" + sum +".\n Do you want to continue?",options)
											.then(function (dialog) 
											{
												e.preventDefault();
												alert("1");
											})
										    .catch(function () {
										        this.errors.push('Distributed amount does not match expense amount.');
										alert("2")
										    });*/
          //alert(sum);
          var answer = confirm(
            "Expense amount is €" +
              parseFloat(this.expense.amount).toFixed(2) +
              " but \n you have distributed €" +
              sum.toFixed(2) +
              ".\n Do you want to continue?"
          );
          if (answer) {
            //some code
          } else {
            this.errors.push(
              "Distributed amount does not match expense amount."
            );
          }
        } else {
          this.errors.push("Distributed amount does not match expense amount.");
        }
      }

      return !!canSubmit && this.errors.length === 0;
    },
    save() {
      this.submitted = true;
      if (!this.checkForm()) return;
      /*   this.checkForm();			  
                                window.axios.post('/admin/additionalexpense/save/'+this.building_id, { 
                                expense: this.expense,
                                properties: this.properties,
                                //  debtor_id:this.debtor_id,
                                })
                                .then(() => {
                                
                                    window.location = '/admin/statment/' + this.building_id;

                            })
                            .catch(error => {
                                alert(error);
                                // console.log(error.response)
                            });*/

      this.$http
        .post("/additionalexpenses", {
            expense: this.expense,
            vatPercentage: this.vatPercentage,
          properties: this.properties,
        })
        .then(
          () => {
            this.closeModal();
            location.reload();
            this.$router.push({
              name: "controlpanel",
              params: { buildingId: this.buildingId },
            });
          },
          () => {
            // alert('error')
            //  this.infoError = true
            //  this.loader = false
            //   this.password = ''
          }
        );
    },
  },

        computed: {
            getNetAmount() {
                var netAmount = 0
                this.expense.netAmount = 0
                this.expense.vatAmount = 0
                if (this.expense == undefined || this.expense.expenseTypeId == undefined || this.expense.amount == undefined || this.expense.amount == 0) {

                    this.expense.netAmount = 0
                    this.expense.vatAmount = 0
                    return 0;
                }
                var expenseTemp = this.expenseTypes.find(expenseType => {
                    return expenseType.id == this.expense.expenseTypeId
                })

                netAmount = (this.expense.amount * 100) / (100 + expenseTemp.vatPercentage)

                this.expense.netAmount = netAmount;
                this.expense.vatAmount = this.expense.amount - this.expense.netAmount;

                return netAmount
            },
    TotalAmount() {
      var totalAmount = 0;
      for (var i = 0; i < this.properties.length; i++) {
          totalAmount += parseFloat(this.properties[i].amount == undefined ? 0 : this.properties[i].amount);
      }
      return parseFloat(totalAmount).toFixed(2);
    },
    formIsNotValid() {
      if (
        !this.expense.expenseTypeId ||
        !this.expense.supplierId ||
        !this.expense.amount ||
        !this.expense.dueDate
      ) {
        return true;
      }
    },
  },
};
</script>
